module.exports = __webpack_public_path__ + "static/hero-f033eea34ed0c2b7ba0e92a2fc209c5a.mp4";